import React, {ReactElement} from 'react';
import smsIconSrc from '@assets/images/medops/sms.svg';

const SmsIcon = (props: any): ReactElement => {
  return <img src={smsIconSrc} {...props} />;
};
export default SmsIcon;
